<header>
    <div [class.menu-open]="menuOpen" class="header-item header-item-menu has-hover">
        <i (click)="openMenu()"
           [matTooltip]="(menuOpen ? 'HEADER.MENU.CLOSE_MENU' : 'HEADER.OPEN_MENU') | translate"
           class="icon-burger"
           matTooltipPosition="below"></i>
    </div>

    <div class="header-item header-item-logo">
        <app-logo [size]="'30px'"></app-logo>

    </div>

    <div class="header-item header-item-logo header-item-project-logo">
        <app-logo-project [size]="'30px'"></app-logo-project>
    </div>

    <div class="header-item header-item-separator"></div>

    <div #buttonCharacter (click)="openCharacterDropdown()" class="header-item header-item-user has-drop">
        <div class="header-item has-hover h-100">
            <div class="user-face" (click)="toggleCharacterDropdown($event)">
                <i class="icon-user"></i>
            </div>
            <div class="user-data" (click)="toggleCharacterDropdown($event)">
                <div class="user-data-name">{{ user.fullName }}</div>
                <div class="user-data-character">
                    {{ user.activeCharacter.name }} [{{ user.activeCharacter.role | roleLabel | translate }}]
                </div>
            </div>
        </div>


        <div class="header-drop" *ngIf="characterDropdown" #list>
            <div class="list-group">
                <ul class="list-unstyled">
                    <li class="list-group-item list-group-item-action"
                        [class.active]="character.active"
                        (click)="changeCharacter(character)"
                        *ngFor="let character of user.characters | pageNumber : page : pageSize">
                        <div class="user">{{ character.name }}</div>
                        <div class="user-sub">{{ character.role | roleLabel | translate }}</div>
                    </li>
                </ul>
            </div>
            <div class="paginator" *ngIf="user.characters.length > pageSize">
                <div class="row no-gutters align-items-center">
                    <div class="col-auto">
                        <button class="btn btn-link btn-slim pagination-left"
                                (click)="setPage($event, page - 1)"
                                [class.disabled]="!page > 0">
                            <i class="icon-arrow-left"></i>
                        </button>
                    </div>

                    <div class="col paginator-counter">
                        {{ 'LABEL.PAGINATOR' | translate : {page: (page + 1), pages: numberOfPages} }}
                    </div>

                    <div class="col-auto">
                        <button class="btn btn-link btn-slim pagination-right"
                                (click)="setPage($event, page + 1)"
                                [class.disabled]="!(page + 1 < numberOfPages)">
                            <i class="icon-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div (click)="logout()" class="header-item header-item-exit has-hover">
        <i class="icon-exit"></i>
    </div>

</header>
